import { urlBuilder } from '../../../../Shared/urlBuilder';
import { convertToMoneyWithDefault } from '../../../shared/helpers/utils';

export function handleSetupOneTimeDeposit(subAccountId: string, amount: string) {
  const currentPath = window.location.pathname;
  const normalizedDollarAmount = convertToMoneyWithDefault(amount).dollars;

  return urlBuilder.appSubAccountOneTimeDepositSetupNew.absolute({
    subAccountId,
    amount: normalizedDollarAmount,
    return_to: currentPath,
  });
}

export function handleSetupRecurringDeposit(
  subAccountId: string,
  amount?: string,
  automaticDepositConfigId?: number | null
) {
  const currentPath = window.location.pathname;
  const normalizedDollarAmount = convertToMoneyWithDefault(amount).dollars;

  if (automaticDepositConfigId) {
    return urlBuilder.appAutomaticDepositConfigEdit.absolute({
      automaticDepositConfigId,
      amount: normalizedDollarAmount,
      return_to: currentPath,
    });
  }

  return urlBuilder.appDepositSetup.absolute({
    sub_account_id: subAccountId,
    frequency: 'Twice a month',
    amount: normalizedDollarAmount / 2,
    return_to: currentPath,
  });
}

export function handleSetupAnnualContributions(amount: string, goalId: number) {
  const currentPath = window.location.pathname;
  const normalizedDollarAmount = convertToMoneyWithDefault(amount).dollars;

  return urlBuilder.appAdviceAccountContributionsEdit.absolute({
    goalId,
    annual_total_planned_contribution_amount: normalizedDollarAmount,
    returnTo: currentPath,
  });
}

export function handleSaveRetirementTarget(options: {
  goalId: number;
  retirementAge: number;
  retirementZip: string;
  targetMonthlySpendingAmount: string;
}) {
  const currentPath = window.location.pathname;

  return urlBuilder.appGoalsEditPersonalizedRetirementPlan.absolute({
    goalId: options.goalId,
    retirement_age: options.retirementAge,
    retirement_zip: options.retirementZip,
    annual_desired_retirement_income_override_amount:
      convertToMoneyWithDefault(options.targetMonthlySpendingAmount).dollars * 12,
    return_to: currentPath,
  });
}

export function handleSetupWithdrawal(subAccountId: string, amount: string) {
  const currentPath = window.location.pathname;
  const normalizedDollarAmount = convertToMoneyWithDefault(amount).dollars;

  return urlBuilder.appWithdrawalSetup.absolute({
    frequency: 'Monthly',
    sub_account_id: subAccountId,
    amount: normalizedDollarAmount,
    return_to: currentPath,
  });
}
